import {Validators} from '@angular/forms';

import * as moment from 'moment';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, DatepickerControl, SelectControl} from '../../../app/shared/classes';
import {environment} from 'appEnv/environment';

export const SourceOfFundIdSelector = 'sourceOfFundId';
export const SourceOfFundSelector = 'sourceOfFund';
export const SourceOfFundFromSelector = 'sourceOfFundFrom';
export const SourceOfFundToSelector = 'sourceOfFundTo';
export const SourceOfFundIdentityNameSelector = 'sourceOfFundIdentityName';
export const SourceOfFundTypeSelector = 'sourceOfFundType';
export const SourceOfFundTypeSelectSelector = 'sourceOfFundTypeSelect';
export const SourceOfFundsFormArraySelector = 'sourceOfFundsFormArray';

export const SourceOfFundsStringMaxLength = 256;

export const SourceOfFundControls = (isAlaricTenant: boolean): BaseControl[] => {
    return [
        new BaseControl({
            name: SourceOfFundIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text
        }),
        new SelectControl({
            name: SourceOfFundSelector,
            value: null,
            placeholder: 'Source of fund',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new DatepickerControl({
            name: SourceOfFundFromSelector,
            value: null,
            placeholder: 'From',
            validators: !isAlaricTenant ? [] : [Validators.required],
            componentType: ComponentTypesEnum.Datepicker,
            maxDate: moment().format(environment.dateFormatLocalDate),
            minDate: moment().format('1930-01-01'),
            floatingLabelNever: true
        }),
        new DatepickerControl({
            name: SourceOfFundToSelector,
            value: null,
            placeholder: 'To',
            validators: !isAlaricTenant ? [] : [Validators.required],
            componentType: ComponentTypesEnum.Datepicker,
            maxDate: moment().format(environment.dateFormatLocalDate),
            minDate: moment().format('1930-01-01'),
            floatingLabelNever: true
        }),
        new BaseControl({
            name: SourceOfFundIdentityNameSelector,
            value: null,
            placeholder: null,
            validators: [Validators.maxLength(SourceOfFundsStringMaxLength)],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true,
            hidden: true
        }),
        new BaseControl({
            name: SourceOfFundTypeSelector,
            value: null,
            placeholder: null,
            validators: [Validators.maxLength(SourceOfFundsStringMaxLength)],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true,
            hidden: true
        }),
        new SelectControl({
            name: SourceOfFundTypeSelectSelector,
            value: null,
            placeholder: 'Type',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true,
            hidden: true
        }),
    ];
};
